import { Field, PasswordField } from '@/shared/ui/Form'

/**
 * Campos de redefinição.
 *
 * Como no cadastro, os dois campos tinham `InputGroup` próprio com botão de olho
 * e o mesmo rótulo fixo — inclusive no campo de confirmação. Ambos passam a ser
 * `PasswordField`.
 */
export function ResetPasswordFields() {
  return (
    // Ritmo vertical pelo container, não por margem no filho (MASTER §7 L4).
    <div className="flex flex-col gap-4">
      <Field name="password">
        <Field.Label>Senha</Field.Label>
        <Field.Control>
          <PasswordField autoComplete="new-password" />
        </Field.Control>
        <Field.Description>Use 8 ou mais caracteres.</Field.Description>
        <Field.Error />
      </Field>

      <Field name="password_confirmation">
        <Field.Label>Confirme sua senha</Field.Label>
        <Field.Control>
          <PasswordField autoComplete="new-password" />
        </Field.Control>
        <Field.Error />
      </Field>
    </div>
  )
}
